import { render, staticRenderFns } from "./MoleculeProjectFilters.vue?vue&type=template&id=dfc20434&"
import script from "./MoleculeProjectFilters.vue?vue&type=script&lang=js&"
export * from "./MoleculeProjectFilters.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeProjectFilters.vue?vue&type=style&index=0&id=dfc20434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeSidebarHeader.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2Fbuilding%2FMoleculeProjectFilters.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingMoleculeProjectFiltersDropdown: require('/app/components/molecules/project/building/MoleculeProjectFiltersDropdown.vue').default,AtomsCommonAtomRadio: require('/app/components/atoms/common/AtomRadio.vue').default})
